<template>

    <v-container>

        <v-layout row wrap>

            <v-flex xs12 sm12 mb-2>

                <v-btn class="secondary white--text" @click.stop="openDialog(null)">
                    New Offer
                    <v-icon class="white--text" right>add</v-icon>
                </v-btn>

            </v-flex>

        </v-layout>

        <v-layout row wrap>

            <v-flex xs12 sm12>
                <v-layout row>
                    <v-flex xs12>

                        <v-card>
                            <v-card-title>
                                <v-card-title class="headline">
                                    Offers
                                </v-card-title>
                                <v-spacer/>
                                <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                        clearable
                                />
                            </v-card-title>

                          <!-- Status Or Filter Header-->
                          <v-layout row wrap>

                            <v-flex xs12 md2 pl-4 pr-2>
                              <v-autocomplete
                                clearable
                                :items="getCustomers"
                                label="Customer"
                                v-model="selectedCustomersID"
                                item-value="id"
                                item-text="name"
                                :search-input.sync="searchCustomer"
                                height="48"
                              />
                            </v-flex>


                            <v-flex xs12 md2 pl-4 pr-2>
                              <v-badge
                                v-model="selectedOfferStatusesIDs.length > 0" left>
                                <template v-slot:badge>
                                  <span v-if="selectedOfferStatusesIDs.length > 0">{{ selectedOfferStatusesIDs.length }}</span>
                                </template>

                                <v-autocomplete style="max-width: 250px"
                                                clearable
                                                :items="offerStatuses"
                                                label="Offer Status"
                                                v-model="selectedOfferStatusesIDs"
                                                item-value="id"
                                                item-text="name"
                                                multiple
                                                chips
                                                deletable-chips
                                                small-chips
                                                height="48"
                                />
                              </v-badge>

                            </v-flex>

                            <v-flex xs12 md2 pl-4 pr-2>
                              <v-badge
                                v-model="selectedOfferFollowUpStatusesIDs.length > 0" left>
                                <template v-slot:badge>
                                  <span v-if="selectedOfferFollowUpStatusesIDs.length > 0">{{ selectedOfferFollowUpStatusesIDs.length }}</span>
                                </template>

                                <v-autocomplete style="max-width: 250px"
                                                clearable
                                                :items="offerFollowUpStatuses"
                                                label="Follow Up Status"
                                                v-model="selectedOfferFollowUpStatusesIDs"
                                                item-value="id"
                                                item-text="name"
                                                multiple
                                                chips
                                                deletable-chips
                                                small-chips
                                                height="48"
                                />
                              </v-badge>

                            </v-flex>


                            <v-flex grow>

                            </v-flex>

<!--                            <v-flex xs12 md2 pl-4 pr-2>
                              <v-autocomplete
                                label="Filter Dates"
                                multiple
                                :deletable-chips=chipsDeletable
                                v-model="selectedDateFilters"
                                item-text="displayName"
                                :items="dateFilters"
                                return-object
                                clearable
                                height="48"
                              >

                              </v-autocomplete>
                            </v-flex>-->
<!--                            <v-flex xs12 md2 pl-4 pr-2>
                              <v-menu
                                ref="menu"
                                v-model="selectFromMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    :value="selectFromDate | toDateOnly"
                                    label="Select From"
                                    prepend-icon="fal fa-calendar-alt"
                                    readonly
                                    v-on="on"
                                    height="48"
                                  />
                                </template>
                                <v-date-picker v-model="selectFromDate" @input="selectFromMenu = false" no-title
                                               scrollable>
                                  <v-spacer/>
                                  <v-btn flat color="primary"
                                         @click="resetDate(selectFromDate, selectFromMenu)">CLEAR
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-flex>-->

<!--                            <v-flex xs12 md2 pl-4 pr-2>
                              <v-menu
                                ref="menu"
                                v-model="selectToMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    :value="selectToDate | toDateOnly"
                                    label="Select To"
                                    prepend-icon="fal fa-calendar-alt"
                                    readonly
                                    v-on="on"
                                    height="48"
                                  />
                                </template>
                                <v-date-picker v-model="selectToDate" @input="selectToMenu = false" no-title
                                               scrollable>
                                  <v-spacer/>
                                  <v-btn flat color="primary" @click="resetDate(selectToDate, selectToMenu)">
                                    CLEAR
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-flex>-->


                          </v-layout>

                            <v-data-table
                                    :headers="headers"
                                    :items="getItems"
                                    :pagination.sync="pagination"
                                    :total-items=total
                                    class="elevation-0"
                                    :loading="loading"
                                    :rows-per-page-items="rowsPageItems"
                            >

                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <v-touch tag="tr"
                                             @doubletap="openDialog(props.item.id)"
                                             @dblclick="openDialog(props.item.id)">
                                        <td>{{ props.item.id }}</td>
                                        <td class="text-xs-left">{{ props.item.offer_number }}</td>
                                        <td class="text-xs-left">{{ getProjectNumber(props.item) }}</td>
                                        <td class="text-xs-left">{{ getRFQNumber(props.item) }}</td>
                                        <td class="text-xs-left">{{ props.item.customer.name }}</td>
                                        <td class="text-xs-left">{{ props.item.account.firstname }} {{
                                            props.item.account.lastname}}
                                        </td>
                                        <td class="text-xs-center">
                                            <v-progress-linear
                                                    slot="progress"
                                                    :value="calculateProgress(props.item.id)"
                                                    :color="color(props.item.id)"
                                                    height="7"
                                            />
                                        </td>

                                        <td class="text-xs-center">
                                            {{ getOfferPositionCount(props.item.customers_offers_positions) }} / {{
                                            props.item.customers_offers_positions.length }}
                                        </td>
                                        <td class="text-xs-left">{{ props.item.customers_offers_status.name }}</td>
                                        <td class="text-xs-left"> {{ props.item.valid_until | toDateOnly }}</td>
                                        <td class="text-xs-right"> {{ props.item.customers_offers_follow_up_status_reminder | toDateTimeLocalTime }}</td>
                                        <td class="text-xs-right"> {{ getPropertyByPath(props.item,'customers_offers_follow_up_status.name', '-')}}</td>
                                        <td v-if=" getPropertyByPath(props.item,'total_sales_price.totalSalesPrice', 0) > 0" class="text-xs-right">{{ getPropertyByPath(props.item,'total_sales_price.totalSalesPrice', '-') | toMoney }} {{props.item.currency.name}}</td>
                                        <td v-else class="text-xs-right">-</td>
                                        <td class="text-xs-right"> {{ props.item.created_at | toDateTimeLocalTime }}</td>
                                    </v-touch>

                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                </v-layout>

                <addOfferDialog/>

            </v-flex>
        </v-layout>

    </v-container>

</template>

<script>
    import {
        Settings,
        Offer,
        Customer
    } from '../../store/namespace-helper'
    import addOfferDialog from '../Offers/AddOfferDialog.vue'
    import _ from 'lodash'
    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
    import {stateHelperMixin} from '../../mixins/stateHelperMixin'
    import {numberFormatFilters} from '../../mixins/numberFormatFilters'
    import {propertyHelperMixin} from '../../mixins/propertyHelperMixin'

    export default {
      name: 'customers',
      components: {
        addOfferDialog
      },
      mixins: [dateFunctionFilters, stateHelperMixin, numberFormatFilters, propertyHelperMixin],
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'Offer-ID', value: 'id'},
                    {text: 'Offer Number', value: 'offer_number'},
                    {text: 'Inquiry Number', value: 'project_number', sortable: false},
                    {text: 'RFQ Number', value: 'rfq_number', sortable: false},
                    {text: 'Customer', value: 'customers:customers_id|customers.name', sortable: true},
                    {text: 'Account', value: 'accounts:accounts_id|accounts.firstname'},
                    {text: 'Progress', value: 'progress', sortable: false, align: 'left'},
                    {text: 'Calculated Positions', value: 'calc_position', sortable: false, align: 'center'},
                    {text: 'Status', value: 'customers_offers_status_id', sortable: false},
                    {text: 'Valid Until', value: 'valid_until'},
                    {text: 'Follow Up Reminder', value: 'customers_offers_follow_up_status_reminder', sortable: true},
                    {text: 'Follow Up Status', value: 'customersOffersFollowUpStatus.name', sortable: false},
                    {text: 'Total Sales Price', value: 'totalSalesPrice', sortable: false},
                    {text: 'Created', value: 'created_at'}
          ],
          pagination: {'sortBy': 'id', 'descending': true},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [25, 10, 50, 100, 250],
          offerStatuses: [],
          offerFollowUpStatuses: [],
          selectedOfferStatusesIDs: [],
          selectedOfferFollowUpStatusesIDs: [],
          selectedCustomersID: null,
          searchCustomer: null
        }
      },
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadItems()
        this.loadStatuses()
        // applying styles to selector filters
        let selectors = document.getElementsByClassName('v-select__selections')
        for (let i = 0; i < selectors.length; i++) {
          selectors[i].style.maxHeight = '42px'
          selectors[i].style.overflowX = 'scroll'
        }
      },
      methods: {
        openDialog (val) {
          if (val !== null) {
            let item = this.getItems.find(x => x.id === val)
            this.$store.dispatch(Offer.actions.setSelectedOffer, item)
          }
          this.$store.dispatch(Offer.actions.openCloseDialog)
        },
        loadItems () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : '',
            customers_id: this.selectedCustomersID ? this.selectedCustomersID : 0,
/*            selectedFrom: this.selectFromDate ? this.selectFromDate : null,
            selectedTo: this.selectToDate ? this.selectToDate : null,
            filterDates: this.selectedDateFilters, */
            selectedOfferFollowUpStatuses: this.selectedOfferFollowUpStatusesIDs,
            selectedOfferStatuses: this.selectedOfferStatusesIDs
          }
          this.$store.dispatch(Offer.actions.loadOffers, query)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        loadCustomers () {
          const query = {
            search: this.searchCustomer ? this.searchCustomer : ''
          }
          this.$store.dispatch(Customer.actions.loadCustomers, query)
        },
        loadStatuses () {
          this.$store.dispatch(Offer.actions.loadStatuses).then(response => {
            this.offerStatuses = response.data.data
          })
          this.$store.dispatch(Offer.actions.loadFollowUpStatuses).then(response => {
            this.offerFollowUpStatuses = response.data.data
          })
        },
        color (val) {
          let item = this.getItems.find(x => x.id === val)
          if (this.getOfferPositionCount(item.customers_offers_positions) === item.customers_offers_positions.length) {
            return 'success'
          } else if (this.getOfferPositionCount(item.customers_offers_positions) === 0) {
            return 'error'
          } else {
            return 'warning'
          }
        },
        calculateProgress (val) {
          if (val !== null) {
            let item = this.getItems.find(x => x.id === val)
            return (100 / item.customers_offers_positions.length) * this.getOfferPositionCount(item.customers_offers_positions)
          } else {
            return 0
          }
        },
        getOfferPositionCount (val) {
          let count = 0
          val.forEach(function (item) {
            if (item.customers_offers_positions_status_id >= 2) {
              count += 1
            }
          })
          return count
        },
        getProjectNumber (val) {
          if (typeof val.inquiry !== 'undefined' && val.inquiry !== null) {
            return val.inquiry.project_number
          } else {
            return '-'
          }
        },
        getRFQNumber (val) {
          if (typeof val.inquiry !== 'undefined' && val.inquiry !== null) {
            return val.inquiry.rfq_number
          } else {
            return '-'
          }
        }
      },
      computed: {
        getItems () {
          this.total = this.$store.getters[Offer.getters.offers].total
          return this.$store.getters[Offer.getters.offers].data
        },
        getCustomers () {
          return this.$store.getters[Customer.getters.customers]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        dialogState () {
          return this.$store.getters[Offer.getters.getOpenDialogState]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        dialogState: {
          handler (val) {
            if (!val) {
                        // cleanup states
                        // reload supplier list
              this.throttledLoadItems()
            }
          },
          deep: true
        },
        selectedCustomersID: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectFromDate: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectToDate: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectedDateFilters: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectedOfferStatusesIDs: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        selectedOfferFollowUpStatusesIDs: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        searchCustomer: {
          handler (val) {
            this.loadCustomers()
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Offers/Offers.vue